var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-nav-bar',{attrs:{"title":_vm.pageTitle,"left-text":_vm.leftArrow ? _vm.leftText : '',"left-arrow":_vm.leftArrow,"right-text":_vm.rightText,"fixed":_vm.fixed,"z-index":"99"},on:{"click-left":_vm.onClickLeft,"click-right":_vm.onClickRight}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }